import type { CSSProperties } from "react";

export interface SpinnerProps {
  size?: number;
  color?: string;
  thickness?: number;
  style?: CSSProperties;
}

/** Indeterminate loading spinner. */
export function Spinner({
  size = 20,
  color = "var(--color-brand-primary)",
  thickness = 2,
  style,
}: SpinnerProps) {
  return (
    <span
      role="status"
      aria-label="Завантаження"
      style={{
        width: size,
        height: size,
        display: "inline-block",
        borderRadius: "50%",
        border: `${thickness}px solid var(--neutral-200)`,
        borderTopColor: color,
        animation: "cf-spin 0.7s linear infinite",
        ...style,
      }}
    />
  );
}

export interface SkeletonProps {
  width?: number | string;
  height?: number | string;
  radius?: number | string;
  style?: CSSProperties;
}

/** Shimmer placeholder block for loading states. */
export function Skeleton({
  width = "100%",
  height = 14,
  radius = "var(--radius-sm)",
  style,
}: SkeletonProps) {
  return (
    <span
      style={{
        display: "block",
        width,
        height,
        borderRadius: radius,
        background:
          "linear-gradient(90deg, var(--neutral-100) 25%, var(--neutral-150) 37%, var(--neutral-100) 63%)",
        backgroundSize: "200% 100%",
        animation: "cf-skeleton 1.4s ease infinite",
        ...style,
      }}
    />
  );
}
